module.exports = __webpack_public_path__ + "static/media/ic_删除2.7d4f2bb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_删除2.svg
// module id = 345
// module chunks = 0